import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LOGIN } from "@/constants/testIds";
import AuthLayout from "@/components/AuthLayout";
import GoogleLoginButton from "@/components/GoogleLoginButton";
import { formatApiError } from "@/lib/api";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            await login(email, password);
            navigate("/dashboard");
        } catch (err) {
            setError(formatApiError(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout title="Welcome back" subtitle="Sign In">
            <GoogleLoginButton />
            <div className="my-6 flex items-center gap-4 text-xs tracking-[0.2em] uppercase text-navy-400">
                <div className="h-px flex-1 bg-navy-100"></div>
                <span>or</span>
                <div className="h-px flex-1 bg-navy-100"></div>
            </div>
            <form onSubmit={onSubmit} className="space-y-4">
                <div>
                    <label className="block text-xs tracking-[0.18em] uppercase text-navy-500 font-semibold mb-2">Email</label>
                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        data-testid={LOGIN.emailInput}
                        className="w-full bg-linen border border-navy-100 rounded-xl px-5 py-3.5 focus:ring-2 focus:ring-gold focus:border-transparent outline-none font-sans transition-all"
                        placeholder="you@example.com"
                    />
                </div>
                <div>
                    <label className="block text-xs tracking-[0.18em] uppercase text-navy-500 font-semibold mb-2">Password</label>
                    <input
                        type="password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        data-testid={LOGIN.passwordInput}
                        className="w-full bg-linen border border-navy-100 rounded-xl px-5 py-3.5 focus:ring-2 focus:ring-gold focus:border-transparent outline-none font-sans transition-all"
                        placeholder="••••••••"
                    />
                </div>
                {error && <div className="text-sm text-red-600 font-sans">{error}</div>}
                <button
                    type="submit"
                    disabled={loading}
                    data-testid={LOGIN.submitButton}
                    className="w-full font-sans text-xs uppercase tracking-[0.18em] bg-navy text-white rounded-lg px-6 py-4 hover:bg-navy-700 active:scale-95 transition-all shadow-lg shadow-navy/20 disabled:opacity-50"
                >
                    {loading ? "Signing in…" : "Sign In"}
                </button>
            </form>
            <p className="mt-6 text-sm text-navy-500 font-sans text-center">
                New to HolyMarry?{" "}
                <Link to="/register" data-testid={LOGIN.registerLink} className="text-navy font-semibold hover:text-gold-600">Create an account</Link>
            </p>
        </AuthLayout>
    );
}
